import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Phone, Linkedin, Facebook } from "lucide-react";
import { Link } from "react-router-dom";
import logoUniverseitWhite from "@/assets/logo-universeit-white.png";
import microsoftPartnerBadge from "@/assets/microsoft-partner-badge.png";
const Footer = () => {
  const quickLinks = [
    { name: "Solutions", href: "/solutions" },
    { name: "About Us", href: "/about-us" },
    { name: "Schedule a Call", href: "https://universeit.com/schedule-a-call", external: true },
    { name: "M365 Security Assessment", href: "https://universeit.com/m365-security-assessment", external: true },
    { name: "M365 Explorer", href: "/m365-explorer" },
  ];
  const socialLinks = [
    {
      name: "LinkedIn",
      icon: Linkedin,
      href: "https://www.linkedin.com/company/universeit/",
    },
    {
      name: "X",
      icon: () => (
        <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
      ),
      href: "https://x.com/UniverseIT_",
    },
    {
      name: "Facebook",
      icon: Facebook,
      href: "https://www.facebook.com/people/Universeit/100057828602598/",
    },
    {
      name: "Instagram",
      icon: () => (
        <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
        </svg>
      ),
      href: "https://www.instagram.com/real_universeit",
    },
    {
      name: "YouTube",
      icon: () => (
        <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor">
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
        </svg>
      ),
      href: "https://www.youtube.com/channel/UC6HfZqReC67y14_Sw7dCQxQ",
    },
  ];
  return (
    <footer className="bg-footer border-t border-cosmic-strong text-footer-foreground">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
            {/* Company Info */}
            <div className="lg:col-span-2">
              <Link to="/">
                <img
                  src={logoUniverseitWhite}
                  alt="UniverseIT - Beyond the Cloud"
                  className="h-10 lg:h-12 w-auto mb-4"
                  width="174"
                  height="40"
                  loading="lazy"
                />
              </Link>
              <p className="text-footer-muted mb-6 max-w-md">
                Empowering businesses with custom-tailored IT solutions, ERP implementations, and managed services that
                drive growth and efficiency.
              </p>

              {/* Contact Info */}
              <div className="space-y-3 mb-6">
                <div className="flex items-center gap-3 text-sm text-footer-muted">
                  <Phone className="h-4 w-4 text-primary" />
                  <span>+1 (833)-HIRE-UIT</span>
                </div>
              </div>

              {/* CTA */}
              <a href="https://universeit.com/schedule-a-call" target="_blank" rel="noopener noreferrer">
                <Button variant="cosmic">
                  Schedule a Call
                </Button>
              </a>


              <img
                src={microsoftPartnerBadge}
                alt="Microsoft Tier-1 Cloud Solutions Provider - Solutions Partner for Business Applications, Modern Work, Security"
                className="w-[270px] h-auto mt-[30px]"
                width="270"
                height="auto"
                loading="lazy"
              />
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="font-semibold text-footer-foreground mb-4">Quick Links</h3>
              <ul className="space-y-3">
                {quickLinks.map((item) => (
                  <li key={item.name}>
                    {item.external ? (
                      <a
                        href={item.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-footer-muted hover:text-primary transition-smooth text-sm"
                      >
                        {item.name}
                      </a>
                    ) : (
                      <Link to={item.href} className="text-footer-muted hover:text-primary transition-smooth text-sm">
                        {item.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h3 className="font-semibold text-footer-foreground mb-4">Our Offices</h3>
              <div className="space-y-4 text-sm text-footer-muted">
                <div>
                  <p className="font-semibold text-footer-foreground mb-1">Houston</p>
                  <p>2245 Texas Dr.</p>
                  <p>Ste 300</p>
                  <p>Sugar Land, TX 77479</p>
                </div>

                <div>
                  <p className="font-semibold text-footer-foreground mb-1">Denver</p>
                  <p>PMB# 6155</p>
                  <p>1600 Brodway</p>
                  <p>Suite 1600</p>
                </div>
              </div>
            </div>

            {/* Hours */}
            <div>
              <h3 className="font-semibold text-footer-foreground mb-4">Hours</h3>
              <div className="space-y-4 text-sm text-footer-muted">
                <div>
                  <p className="font-semibold text-footer-foreground mb-1">Office Hours</p>
                  <p>M-F, 8:30 AM - 5:30 PM CST</p>
                </div>

                <div>
                  <p className="font-semibold text-footer-foreground mb-1">US Support Hours</p>
                  <p>M-F, 7:30 AM - 6:00 PM CST</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Separator className="bg-footer-muted/20" />

        {/* Bottom Footer */}
        <div className="py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-sm text-footer-muted">© 2024 UniverseIT. All rights reserved.</div>

          <div className="flex items-center gap-4">
            {/* Social Links */}
            <div className="flex items-center gap-3">
              {socialLinks.map((item) => {
                const Icon = item.icon;
                return (
                  <a
                    key={item.name}
                    href={item.href}
                    aria-label={`Follow UniverseIT on ${item.name}`}
                    className="w-8 h-8 bg-footer-muted/20 text-footer-muted rounded-full flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition-spring"
                  >
                    <Icon className="h-4 w-4" />
                  </a>
                );
              })}
            </div>

            <Separator orientation="vertical" className="h-4 bg-footer-muted/20" />

            {/* Legal Links */}
            <div className="flex items-center gap-4 text-sm">
              <Link to="/privacy-policy" className="text-footer-muted hover:text-primary transition-smooth">
                Privacy Policy
              </Link>
              <Link to="/sms-terms" className="text-footer-muted hover:text-primary transition-smooth">
                SMS Terms
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
